// Watchpoint module routes with lazy loading
import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import { lazy, Suspense } from 'react'

// Lazy load components
const Dashboard = lazy(() => import('./components/Dashboard'))
const WatchpointList = lazy(() => import('./components/Watchpoint/List'))
const WatchpointCreate = lazy(() => import('./components/Watchpoint/Create'))
const WatchpointDetail = lazy(() => import('./components/Watchpoint/Detail'))
const WatchpointEdit = lazy(() => import('./components/Watchpoint/Edit'))
const AlarmList = lazy(() => import('./components/Alarm/List'))
const ChannelList = lazy(() => import('./components/Channel/List'))
const ChannelDetail = lazy(() => import('./components/Channel/Detail'))
const AlarmEventList = lazy(() => import('./components/AlarmEvent/List'))
const PlaybookList = lazy(() => import('./components/Playbook/List'))
const PlaybookForm = lazy(() => import('./components/Playbook/Form'))
const PlaybookDetail = lazy(() => import('./components/Playbook/Detail'))

// Loading fallback
const LoadingFallback = () => (
    <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
    </div>
)

// Wrapper for lazy components
const withSuspense = (Component: React.LazyExoticComponent<React.FC>) => (
    <Suspense fallback={<LoadingFallback />}>
        <Component />
    </Suspense>
)

const WatchpointModule: RouteObject = {
    path: 'technical/watchpoint',
    children: [
        { path: '', element: withSuspense(Dashboard) },
        { path: 'watchpoints', element: withSuspense(WatchpointList) },
        { path: 'watchpoints/new', element: withSuspense(WatchpointCreate) },
        { path: 'watchpoints/:id', element: withSuspense(WatchpointDetail) },
        {
            path: 'watchpoints/:id/edit',
            element: withSuspense(WatchpointEdit),
        },
        { path: 'alarms', element: withSuspense(AlarmList) },
        { path: 'channels', element: withSuspense(ChannelList) },
        { path: 'channels/:id', element: withSuspense(ChannelDetail) },
        { path: 'events', element: withSuspense(AlarmEventList) },
        { path: 'playbooks', element: withSuspense(PlaybookList) },
        { path: 'playbooks/new', element: withSuspense(PlaybookForm) },
        { path: 'playbooks/:id', element: withSuspense(PlaybookDetail) },
        { path: 'playbooks/:id/edit', element: withSuspense(PlaybookForm) },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default WatchpointModule
